<div 
    *ngIf="asessDetails"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeModal();"
>
    <div class="flex flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <div class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row gap-8 items-center justify-between">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap">
                        Assessment Details
                    </h2>
                    <div *ngIf="canSave()" class="w-full flex flex-row gap-2 items-center justify-end">
                        <div class="relative group">
                            <!-- Delete Button -->
                            <button
                                data-tooltip-target="tooltip-delete" data-tooltip-placement="bottom"
                                (click)="$event.preventDefault(); deleteAssess();"
                                class="flex items-center justify-center p-2 rounded-md border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 oswald-font text-white whitespace-nowrap"
                            >
                                <lucide-icon [name]="icons.Trash2" [size]="20"></lucide-icon>
                            </button>
                            <!-- Tooltip for Delete -->
                            <div id="tooltip-delete" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                Delete Assessment
                                <div class="tooltip-arrow" data-popper-arrow></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full h-full flex flex-col items-center p-4 rounded-lg">
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Assessment Type:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ asessDetails.type_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Sub Type:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ asessDetails.sub_type_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Date requested:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ asessDetails.date_sent | date: 'MM/dd/yyyy - HH:mm' }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Requested by:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ asessDetails.user_name_sent }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Requested to:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ asessDetails.receiver }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Status:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p *ngIf="asessDetails.submitted == 1">Submitted</p>
                            <p *ngIf="asessDetails.submitted == 0">Pending</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Date submitted:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ asessDetails.date_responded | date: 'MM/dd/yyyy - HH:mm' }}</p>
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</div>